import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Tooltip } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import StyledDrawerMenuLogoutContainer from 'common/theme/drawer-menu/StyledDrawerMenuLogoutContainer';
import StyledLogoutButton from 'common/theme/button/StyledLogoutButton';
import { TOUR_REPLAY_EVENT } from 'components/shared/tour/RoleTour';
import SidebarPanelContext from 'context/SidebarPanelContext';

// Relanza el tour de onboarding del rol actual (mismo estilo que el botón de logout).
function DrawerTourButton() {
  const { t } = useTranslation(['tour']);
  const { iconOnly: miniDrawer } = useContext(SidebarPanelContext);

  const replay = () => window.dispatchEvent(new Event(TOUR_REPLAY_EVENT));
  const label = t('replay', { ns: 'tour', defaultValue: 'Ver tutorial guiado' });

  return miniDrawer ? (
    <Tooltip title={label}>
      <IconButton aria-label="tour" data-tour="tour-replay" color="menuItem" onClick={replay} sx={{ alignSelf: 'center' }}>
        <HelpOutline />
      </IconButton>
    </Tooltip>
  ) : (
    <StyledDrawerMenuLogoutContainer data-tour="tour-replay">
      {/* Más pequeño que Salir a propósito: es una ayuda ocasional, no una acción de la
          navegación, y al mismo tamaño competía con los ítems del menú. */}
      <StyledLogoutButton
        color="menuItem"
        onClick={replay}
        startIcon={<HelpOutline sx={{ marginRight: '20px', fontSize: 18 }} />}
        sx={{
          fontSize: (th) => th.typography.pxToRem(11),
          opacity: 0.85,
          [`@media (min-width:1200px)`]: { fontSize: (th) => th.typography.pxToRem(12) }
        }}>
        {label}
      </StyledLogoutButton>
    </StyledDrawerMenuLogoutContainer>
  );
}

export default DrawerTourButton;
